{
  "de": {
    "timetable": {
      "headline": "Organisiere deinen Schulalltag",
      "today": "Heute",
      "month": "Monat",
      "week": "Woche",
      "day": "Tag",
      "weekNumberFormat": "(KW {weekNumber})",
      "dayFormat": "{day}, {date}",
      "previous": "Zurück",
      "next": "Weiter",
      "defaultCalendarTitle": "Mein Stundenplan",
      "calendar": "Stundenplan",
      "createNewTimetable": "Neuen Stundenplan anlegen",
      "settings": "Einstellungen",
      "lastSynced": "Zuletzt synchronisiert:",
      "breakTimeTooltip": "Während der unterrichtsfreien Zeit werden keine Unterrichtsstunden angezeigt.",
      "untisSyncedTooltip": "Kalender synchronisiert von Untis",
      "sync": {
        "chip": {
          "syncing": "Stundenplan wird gerade synchronisiert"
        },
        "toast": {
          "initialSyncing": {
            "title": "Stundenplan wird gerade synchronisiert",
            "body": "Es kann etwas dauern, bis der Stundenplan geladen ist."
          },
          "success": "Stundenplan wurde erfolgreich synchronisiert",
          "errorAuthExpired": "Verbindung zu WebUntis abgelaufen. Bitte verbinde dein Konto erneut.",
          "errorNotConnected": "Kein WebUntis-Konto verbunden",
          "errorNotFound": "Schuljahr in WebUntis nicht gefunden",
          "errorGeneric": "Stundenplan kann gerade nicht synchronisiert werden"
        }
      },
      "offcanvas": {
        "title": "Einstellungen",
        "untisHint": {
          "title": "WebUntis Stundenplan",
          "description": "Dieser Kalender wird {highlightSync} mit deinem WebUntis Stundenplan.",
          "highlightSync": "automatisch synchronisiert",
          "bullet1": "Bei WebUntis kannst du {highlightBullet1}.",
          "highlightBullet1": "Termine ändern oder verschieben",
          "bullet2": "Im fobizz Stundenplan kannst du deine {highlightBullet2}.",
          "highlightBullet2": "Unterrichtsstunden planen"
        },
        "webuntisTip": {
          "title": "Tipp für WebUntis Schulen",
          "linkText": "fobizz.com/untis-plattform"
        },
        "sections": {
          "basicSettings": {
            "title": "Basis Einstellungen",
            "dateRangeLabel": "Zeitraum",
            "dateRange": "Vom {startDate} bis {endDate}",
            "calendarName": "Name",
            "lessonDuration": "Dauer einer Unterrichtsstunde",
            "lessonDurationOption": "{duration} Min.",
            "deleteTimetable": "Stundenplan löschen",
            "validation": {
              "nameRequired": "Bitte gib einen Namen ein.",
              "durationRequired": "Bitte wähle eine Unterrichtsdauer aus."
            }
          },
          "breakTimes": {
            "title": "Ferien & unterrichtsfreie Zeiten",
            "addButton": "Neue Ferienzeit hinzufügen",
            "editEntry": "Eintrag bearbeiten",
            "deleteEntry": "Eintrag löschen",
            "loading": "Lädt Ferienzeiten...",
            "alertTitle": "Gut zu wissen:",
            "alertDescription": "Während der Ferienzeiten werden keine Kurstermine in deinem Stundenplan angezeigt."
          },
          "courses": {
            "title": "Meine Kurse",
            "addCourseButton": "Neuen Kurs hinzufügen",
            "editCourse": "Kurs bearbeiten",
            "deleteCourse": "Kurs löschen",
            "emptyState": {
              "headline": "Lege jetzt deinen ersten Kurs an",
              "description": "Mit deinen Kursen kannst du dann deinen Stundenplan befüllen.",
              "addButton": "Kurs hinzufügen"
            },
            "loading": "Lädt Kurse..."
          }
        },
        "flash": {
          "updateSuccess": "Einstellungen erfolgreich gespeichert",
          "updateFailed": "Fehler beim Speichern der Einstellungen"
        }
      },
      "colors": {
        "label": "Kursfarbe",
        "yellow": "Gelb",
        "orange": "Orange",
        "red": "Rot",
        "magenta": "Magenta",
        "green": "Grün",
        "teal": "Türkis",
        "cyan": "Cyan",
        "patrol": "Patrol",
        "purple": "Lila",
        "purpur": "Purpur",
        "gray": "Grau"
      },
      "errors": {
        "failedToLoadEvent": "Termin konnte nicht geladen werden",
        "failedToSaveEvent": "Termin konnte nicht gespeichert werden"
      },
      "validation": {
        "titleMaxLength": "Der Titel darf maximal {max} Zeichen lang sein",
        "courseNameMaxLength": "Der Kursname darf maximal {max} Zeichen lang sein"
      },
      "create": {
        "headline": "Neuen Stundenplan anlegen",
        "form": {
          "titleLabel": "Titel",
          "namePlaceholder": "Titel eingeben...",
          "dateRangeLabel": "Start- und Enddatum",
          "dateFromLabel": "Von",
          "dateToLabel": "Bis",
          "submitting": "Stundenplan wird angelegt..."
        },
        "validation": {
          "titleRequired": "Bitte gib einen Namen ein",
          "startDateRequired": "Bitte wähle ein Startdatum",
          "invalidStartDate": "Bitte gib ein gültiges Startdatum ein",
          "endDateRequired": "Bitte wähle ein Enddatum",
          "invalidEndDate": "Bitte gib ein gültiges Enddatum ein",
          "endDateAfterStart": "Enddatum muss nach dem Startdatum liegen oder gleich sein"
        },
        "flash": {
          "created": "Stundenplan erfolgreich angelegt",
          "createFailed": "Fehler beim Anlegen des Stundenplans"
        }
      },
      "createForm": {
        "nameLabel": "Name des Stundenplans",
        "namePlaceholder": "z. B. Schuljahr 2026/27…",
        "startDateLabel": "Startdatum",
        "endDateLabel": "Enddatum",
        "teachingWeeks": "{count} Unterrichtswoche | {count} Unterrichtswochen",
        "locationLabel": "Schulstandort",
        "international": "International",
        "changeSchool": "Ändern",
        "changeSchoolAriaLabel": "Schule ändern",
        "schoolsLoadFailed": "Deine Schulen konnten nicht geladen werden. Ohne sie lässt sich der Stundenplan noch nicht anlegen.",
        "holidaysHint": "Ferien und Feiertage werden automatisch in deinen Stundenplan übernommen."
      },
      "createChoice": {
        "manual": {
          "title": "Stundenplan selbst anlegen",
          "text": "Zeitraum benennen, Stunden anschließend selbst eintragen.",
          "button": "Selbst erstellen"
        },
        "or": "oder",
        "untis": {
          "title": "Nutzt deine Schule WebUntis?",
          "text": "Mit einer Verknüpfung erscheint dein Stundenplan automatisch in fobizz. Deine Stunden werden übernommen – ohne Aufwand, und auch später bei Änderungen.",
          "bulletAutomatic": "Stunden, Klassen und Räume kommen automatisch aus WebUntis.",
          "bulletAdmin": "Einmalig erforderlich: Der WebUntis-Admin deiner Schule schaltet die Verbindung frei.",
          "infoButton": "Allgemeine Infos",
          "dismissButton": "Hinweis nicht mehr anzeigen"
        }
      },
      "createEvent": {
        "title": "Neuen Termin anlegen",
        "courseLabel": "Termin anlegen für:",
        "courseSelection": {
          "placeholder": "Auswählen...",
          "newCourse": "Neuer Kurs",
          "otherEvent": "Anderer Termin",
          "selectCourse": "Kurs auswählen",
          "loading": "Lädt Kurse...",
          "courses": "Kurse",
          "courseSectionLabel": "Unterrichtsstunde in Kurs",
          "otherEventSectionLabel": "Anderer Termin"
        },
        "dateAndRecurrence": "Wochentag und Wiederholung",
        "recurrenceLabel": "Wiederholung",
        "recurrenceOptions": {
          "onetime": "Einmalig",
          "weekly": "Wöchentlich",
          "biweekly": "Zweiwöchentlich",
          "quadweekly": "Alle 4 Wochen"
        },
        "durationLabel": "Dauer",
        "eventTitleLabel": "Titel des Termins",
        "eventTitlePlaceholder": "Titel eingeben...",
        "courseNameLabel": "Kurstitel",
        "courseNamePlaceholder": "z.B. Mathe 7B",
        "courseColorLabel": "Farbe wählen",
        "errors": {
          "endTimeBeforeStart": "Die Endzeit muss nach der Startzeit liegen",
          "createFailed": "Fehler beim Erstellen des Termins"
        }
      },
      "courseModal": {
        "courseNameLabel": "Kursname",
        "courseNamePlaceholder": "Titel eingeben...",
        "courseColorLabel": "Farbe",
        "classroomLabel": "Klassenraum verknüpfen",
        "classroomPlaceholder": "Nicht verknüpft",
        "validation": {
          "courseNameRequired": "Bitte gib einen Kursnamen ein"
        },
        "createCourse": {
          "title": "Neuen Kurs anlegen",
          "create": "Anlegen",
          "errors": {
            "createFailed": "Fehler beim Erstellen des Kurses"
          }
        },
        "editCourse": {
          "title": "Kurs bearbeiten",
          "save": "Speichern",
          "errors": {
            "editFailed": "Fehler beim Aktualisieren des Kurses"
          }
        }
      },
      "deleteCourse": {
        "title": "Kurs löschen?",
        "message": "Achtung: Wenn du diesen Kurs löschst, werden alle damit verbundenen Termine abgesagt (insgesamt {count}). Bist du sicher, dass du den gesamten Kurs löschen willst?",
        "delete": "Ja, löschen",
        "errors": {
          "deleteFailed": "Fehler beim Löschen des Kurses"
        }
      },
      "breakTimeModal": {
        "titleLabel": "Titel",
        "titlePlaceholder": "Sommerferien, Herbstferien,...",
        "startDateLabel": "Von",
        "endDateLabel": "Bis",
        "validation": {
          "titleRequired": "Bitte gib einen Titel ein",
          "startDateRequired": "Bitte wähle ein Startdatum",
          "endDateRequired": "Bitte wähle ein Enddatum",
          "endDateMustBeAfterStartDate": "Das Enddatum muss nach dem Startdatum liegen"
        },
        "createBreakTime": {
          "title": "Unterrichtsfreie Zeiten hinzufügen",
          "success": "Unterrichtsfreie Zeit erfolgreich hinzugefügt",
          "errors": {
            "createFailed": "Fehler beim Hinzufügen der unterrichtsfreien Zeit"
          }
        },
        "editBreakTime": {
          "title": "Unterrichtsfreie Zeit bearbeiten",
          "success": "Unterrichtsfreie Zeit erfolgreich aktualisiert",
          "errors": {
            "editFailed": "Fehler beim Aktualisieren der unterrichtsfreien Zeit"
          }
        }
      },
      "deleteBreakTime": {
        "title": "Unterrichtsfreie Zeit löschen?",
        "message": "Der Eintrag wird aus deinem Stundenplan entfernt.",
        "delete": "Ja, löschen",
        "errors": {
          "deleteFailed": "Fehler beim Löschen der unterrichtsfreien Zeit"
        }
      },
      "deleteTimetable": {
        "title": "Stundenplan löschen?",
        "message": "Der Stundenplan {calendarName} wird einschließlich aller Einträge gelöscht.",
        "delete": "Ja, löschen",
        "success": "Stundenplan erfolgreich gelöscht",
        "errors": {
          "deleteFailed": "Fehler beim Löschen des Stundenplans"
        }
      },
      "lessonPlan": {
        "entryButton": "Unterrichtsentwurf 🤓",
        "tabsLabel": "Unterrichtsstunde und Unterrichtsentwurf",
        "lessonTab": "Unterrichtsstunde",
        "planTab": "Unterrichtsentwurf",
        "minutes": "Min.",
        "bufferDuration": "ca. {minutes} Min. · optional",
        "loadErrorTitle": "Unterrichtsentwurf konnte nicht geladen werden",
        "loadError": "Bitte lade die Seite erneut oder versuche es später noch einmal.",
        "form": {
          "title": "Unterrichtsentwurf erstellen",
          "description": "Erstelle einen strukturierten Unterrichtsentwurf aus den Angaben dieser Stunde.",
          "sourceContext": "Titel, Notizen & Materialien",
          "instruction": "Was soll zusätzlich berücksichtigt werden? (optional)",
          "instructionPlaceholder": "z. B. Gruppenarbeit und eine kurze Ergebnissicherung",
          "automatic": "Automatisch",
          "entryType": "Art des Unterrichtseinstiegs",
          "entryTypes": {
            "problem": "Problemorientiert",
            "informative": "Informativ",
            "associative": "Assoziativ",
            "playful": "Spielerisch"
          },
          "lessonFocus": "Fokus der Unterrichtsstunde",
          "lessonFocuses": {
            "presentation": "Präsentation",
            "groupwork": "Gruppenarbeit",
            "solo_work": "Einzelarbeit",
            "creativity": "Kreativität"
          }
        },
        "generate": "Unterrichtsentwurf erstellen 🤓",
        "generating": "Unterrichtsentwurf wird erstellt…",
        "generationError": "Der Unterrichtsentwurf konnte nicht erstellt werden. Du kannst es erneut versuchen.",
        "learningObjectives": "Lernziele",
        "curriculum": {
          "basedOn": "Basiert auf Lehrplänen für {place}.",
          "basedOnWithoutPlace": "Basiert auf Lehrplänen.",
          "hide": "Ausblenden",
          "noSubject": "Aus dem Kursnamen konnten wir kein Fach ableiten. Benenne den Kurs nach dem Fach, zum Beispiel „Mathematik 7b“, dann nutzt die KI beim nächsten Entwurf einen Lehrplan.",
          "notFound": "Für diese Stunde haben wir keinen passenden Lehrplan gefunden.",
          "show": "Anzeigen",
          "unknownRegion": "Ohne Bundesland nutzt die KI keinen Lehrplan.",
          "upload": "Eigenen hochladen"
        },
        "phases": "Unterrichtsverlauf",
        "primaryActors": {
          "learners": "Lernende",
          "mixed": "Lehrkraft und Lernende",
          "teacher": "Lehrkraft"
        },
        "description": "Beschreibung",
        "materials": "Materialien",
        "materialType": "Materialart",
        "selectMaterial": "Material auswählen",
        "createMaterial": "Material erstellen",
        "materialGenerating": "Material wird erstellt…",
        "materialPending": "Material wird vorbereitet…",
        "materialError": "Das Material konnte nicht erstellt werden. Bitte versuche es erneut.",
        "openMaterial": "Material öffnen",
        "createProject": "Projekt erstellen",
        "projectGenerating": "Projekt wird erstellt…",
        "openProject": "Projekt öffnen",
        "projectError": "Das Projekt konnte nicht erstellt werden. Bitte versuche es erneut.",
        "projectClassTypeOnetimeError": "In einem 24-Stunden-Klassenraum können keine weiteren Projekte erstellt werden.",
        "inProject": "Im Projekt",
        "projectModal": {
          "title": "Projekt für „{title}“ erstellen",
          "description": "Wähle die Phasen, aus denen die Aufgaben entstehen. Name, Beschreibung und Werkzeuge werden daraus abgeleitet, bereits erstellte Materialien der Phasen werden verknüpft.",
          "phases": "Phasen",
          "phasesHelp": "Phasen, in denen vor allem die Lehrkraft handelt, sind nicht vorausgewählt.",
          "actor": {
            "teacher": "Lehrkraft",
            "learners": "Lernende",
            "mixed": "Gemeinsam"
          },
          "noPhaseSelected": "Wähle mindestens eine Phase aus.",
          "teacherOnlyPhases": "Wähle mindestens eine Phase aus, in der Lernende aktiv arbeiten.",
          "help": "Optional: Hinweise zur Aufgabenstellung, zum Ton oder zu den freigeschalteten Werkzeugen."
        },
        "instructionsModal": {
          "material": {
            "title": "{material} für „{phase}“ erstellen",
            "description": "Lernziele, Zielgruppe, Phaseninhalt und Aktionsform werden automatisch übergeben.",
            "help": "Optional: Umfang, Schwierigkeitsgrad, Aufgabenformat oder Differenzierung."
          },
          "placeholder": "Weitere Hinweise ergänzen …"
        },
        "materialKinds": {
          "assistant": "KI-Assistent",
          "classroom_screen": "Klassenraum-Bildschirm",
          "pinboard": "Pinnwand",
          "survey": "Umfrage",
          "text_document": "Textdokument",
          "web_page": "Webseite",
          "word_cloud": "Wortwolke",
          "worksheet": "Arbeitsblatt"
        }
      },
      "eventDetails": {
        "headlineLesson": "Unterrichtsstunde planen",
        "headlineOther": "Termin planen",
        "cardHeadlineOther": "Anderer Termin",
        "backLink": "Stundenplan Übersicht",
        "saved": "Änderungen gespeichert",
        "form": {
          "titlePlaceholderLesson": "Thema der Stunde eingeben",
          "titlePlaceholderOther": "Titel eingeben",
          "titleLabel": "Titel",
          "notesLabel": "Notizen",
          "notesPlaceholder": "Schulstunde planen",
          "notesPlaceholderOther": "Termin planen",
          "materialsLabel": "Materialien",
          "projectsLabel": "Projekte",
          "attachProjectButton": "Projekt hinzufügen",
          "dropzoneHint": "Per Drag & Drop hier reinziehen oder",
          "dropzoneSelectFile": "Datei auswählen",
          "lessonTopicLabel": "Lehrstoff",
          "lessonTopicPlaceholder": "Hier kann der Lehrstoff dieser Stunde mit Hilfe von KI aus den obigen Bereichen zusammengefasst werden.",
          "lessonTopicHint": "Du kannst mit Hilfe von KI die Stunde zusammenfassen. Wähle die Inhalte aus, die verwendet werden sollen.",
          "summarizeButton": "Stunde zusammenfassen",
          "summarizeAgainButton": "Stunde erneut zusammenfassen",
          "summarizingButton": "Wird zusammengefasst…",
          "syncToUntisButton": "Zu WebUntis übertragen",
          "summarizeError": "Fehler beim Zusammenfassen der Stunde",
          "syncSuccess": "Lehrstoff erfolgreich zu WebUntis übertragen",
          "syncError": "Übertragung zu WebUntis fehlgeschlagen"
        },
        "addContent": {
          "button": "Inhalte hinzufügen",
          "dialogTitle": "Inhalte hinzufügen",
          "searchPlaceholder": "Suchbegriff...",
          "confirm": "Hinzufügen",
          "myContentTab": "Meine Ablage",
          "toTeachTab": "to teach",
          "toTeachAttachFailed": "Das Arbeitsblatt liegt in deiner Ablage, konnte aber nicht zur Stunde hinzugefügt werden."
        },
        "materialsError": "Fehler beim Speichern der Materialien",
        "discontinueCourse": "Kurs beenden",
        "discontinueSeries": "Terminserie beenden",
        "previousEvent": "Vorherige Stunde",
        "nextEvent": "Nächste Stunde",
        "cancelledLabel": "Entfällt",
        "cancelledNoticeTitleLesson": "Diese Unterrichtsstunde entfällt.",
        "cancelledNoticeTitleOther": "Dieser Termin entfällt.",
        "cancelledNoticeDescription": "Alle Informationen bleiben erhalten und können später weiterverwendet werden."
      },
      "discontinueCourse": {
        "lesson": {
          "title": "Kurs beenden?",
          "message": "Wenn du den Kurs beendest, wird dieser Termin und alle folgenden Termine des Kurses abgesagt.",
          "description": "Möchtest du wirklich alle {count} folgenden Termine dieses Kurses absagen?",
          "confirm": "Ja, beenden"
        },
        "other": {
          "title": "Terminserie beenden?",
          "message": "Wenn du die Terminserie beendest, wird dieser Termin und alle folgenden Termine der Serie abgesagt.",
          "description": "Möchtest du wirklich alle {count} folgenden Termine dieser Serie absagen?",
          "confirm": "Ja, beenden"
        },
        "successMessage": "Kurs wurde erfolgreich beendet",
        "errorMessage": "Fehler beim Beenden des Kurses"
      },
      "cancelEvent": {
        "lesson": {
          "title": "Unterrichtsstunde absagen?",
          "message": "Die Unterrichtsstunde bleibt mit allen Informationen im Stundenplan erhalten und kann wiederhergestellt werden.",
          "confirm": "Ja, absagen",
          "buttonLabel": "Stunde entfällt"
        },
        "other": {
          "title": "Termin absagen?",
          "message": "Der Termin bleibt mit allen Informationen im Stundenplan erhalten und kann wiederhergestellt werden.",
          "confirm": "Ja, absagen",
          "buttonLabel": "Termin entfällt"
        },
        "successMessage": "Termin wurde erfolgreich abgesagt",
        "errorMessage": "Fehler beim Absagen des Termins"
      },
      "restoreEvent": {
        "lesson": {
          "buttonLabel": "Stunde wiederherstellen"
        },
        "other": {
          "buttonLabel": "Termin wiederherstellen"
        },
        "successMessage": "Der Termin wurde wiederhergestellt",
        "errorMessage": "Fehler beim Wiederherstellen des Termins"
      },
      "linkClassroom": {
        "title": "Klassenraum mit diesem Kurs verknüpfen",
        "labelTooltip": "Verknüpfe einen digitalen Klassenraum für diese Lerngruppe mit diesem Kurs. So kannst du einfach Projekte anlegen und Inhalte leichter mit deiner Lerngruppe teilen.",
        "selectPlaceholder": "Auswählen",
        "confirm": "Verknüpfen",
        "cancel": "Abbrechen",
        "success": "Klassenraum wurde erfolgreich verknüpft",
        "error": "Fehler beim Verknüpfen des Klassenraums",
        "buttonLabel": "Klassenraum verknüpfen"
      },
      "attachProject": {
        "title": "Projekt zu Stunde hinzufügen",
        "selectLabel": "Projekte aus {schoolClassName}",
        "selectPlaceholder": "Auswählen",
        "newProject": "Neues Projekt",
        "confirm": "Hinzufügen",
        "cancel": "Abbrechen",
        "error": "Fehler beim Hinzufügen des Projekts"
      },
      "untisImportTeaser": {
        "text": "Deine Schule nutzt WebUntis? Dann kannst du deinen Stundenplan unkompliziert importieren. Infos dazu findest du hier:"
      },
      "untisSyncWarning": {
        "title": "Achtung",
        "body": "Nur die \u201e{highlight}\u201c wird zu WebUntis übertragen \u2014 alle anderen Inhalte bleiben in fobizz.",
        "bodyHighlight": "Lehrstoff Zusammenfassung",
        "callout": "Bestehende Inhalte im Feld \u201eLehrstoff\u201c in WebUntis werden dabei überschrieben.",
        "confirmButton": "Ok, verstanden",
        "cancelButton": "Abbrechen",
        "dontShowAgain": "Hinweis nicht mehr anzeigen"
      },
      "trialModal": {
        "title": "Dein Geschenk: 30 Tage fobizz Pro",
        "intro": "Du hast gerade deinen Untis-Stundenplan mit fobizz verbunden — schön, dass du da bist!",
        "body": "Damit du fobizz richtig ausprobieren kannst, schenken wir dir 30 Tage Pro: {highlight}.",
        "bodyHighlight": "KI-Chat, Materialerstellung und alle Fortbildungen",
        "cancellation": "Du musst nicht kündigen — dein Testzeitraum beendet sich automatisch. Dein Stundenplan bleibt und synchronisiert sich weiter mit WebUntis.",
        "email": "Die Details schicken wir dir auch per E-Mail.",
        "confirmButton": "Zum Stundenplan"
      }
    }
  }
}
